import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import * as moment from 'moment-timezone';
import { decryptField } from '../../../../utils/decrypt-utils';

@Component({
  selector: 'app-assist-list',
  templateUrl: './assist-list.component.html',
  styleUrls: ['./assist-list.component.css']
})
export class AssistListComponent implements OnInit, OnDestroy {
  assists: any[] = [];
  isLoading: boolean = false;
  search: string = '';
  errorMessage: string = '';

  constructor(
    private router: Router,
    private assistService: AssistService
  ) { }

  ngOnInit(): void {
    this.fetchAssists();
  }

  ngOnDestroy(): void { }

  fetchAssists(): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.assistService.getAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          let list: any[] = [];
          if (Array.isArray(res)) {
            list = res;
          } else if (res && Array.isArray(res.data)) {
            list = res.data;
          } else if (res && Array.isArray(res.assists)) {
            list = res.assists;
          }
          this.assists = list.map(item => this.mapAssistItem(item));
        },
        (error) => {
          console.error('Error fetching assists list:', error);
          this.isLoading = false;
          this.errorMessage = 'Failed to load assists list.';
        }
      );
  }

  private mapAssistItem(item: any): any {
    if (!item) return {};

    const accType = item.e_accommodation_type || item.e_accommodations || item.e_accommodation_types || item.e_accommodationtypes || {};
    const accommodationName = accType.name || item.accommodation_type || '—';

    const cityObj = item.e_cities || {};
    const cityName = cityObj.name || item.city_name || item.city || '—';

    const stateObj = item.e_states || {};
    const stateName = stateObj.name || item.state_code || item.state || '—';

    const refNo = item.reference_id || item.reference_no || (item.id ? ('AST-' + item.id) : '—');
    const rawCreatedDate = item.created_date || item.created_at || item.createdAt;
    const formattedCreatedDate = rawCreatedDate && moment(rawCreatedDate).isValid() ? moment(rawCreatedDate).format('MM/DD/YYYY') : '—';

    const statusNum = typeof item.status === 'string' ? parseInt(item.status, 10) : Number(item.status);
    let statusLabel = '—';
    let statusStyle = { 'background-color': '#f3f4f6', 'color': '#374151' };

    switch (statusNum) {
      case 0:
        statusLabel = 'Available';
        statusStyle = { 'background-color': '#2dce89', 'color': '#ffffff' };
        break;
      case 1:
        statusLabel = 'Accepted';
        statusStyle = { 'background-color': '#0d6efd', 'color': '#ffffff' };
        break;
      case 2:
        statusLabel = 'Closed';
        statusStyle = { 'background-color': '#dc3545', 'color': '#ffffff' };
        break;
      default:
        statusLabel = '—';
        statusStyle = { 'background-color': '#f3f4f6', 'color': '#6b7280' };
        break;
    }

    return {
      ...item,
      created_date: rawCreatedDate,
      formatted_created_date: formattedCreatedDate,
      reference_no: refNo,
      accommodation: accommodationName,
      city: cityName,
      state: stateName,
      status_label: statusLabel,
      status_style: statusStyle,
      ref_id: decryptField(item.e_patients && item.e_patients.reference_id),
      ref_name: decryptField(item.e_patients && item.e_patients.reference_name),
      ref_phone: decryptField(item.e_patients && item.e_patients.reference_phone)
    };
  }

  selectedReferenceId: string | null = null;
  selectedMemberId: string = null;

  onCreateAssist(): void {
    this.router.navigate(['/placement/assists/create']);
  }

  openAssistDetails(assist: any): void {
    const refId = assist ? (assist.reference_id || assist.reference_no || assist.id) : null;
    if (refId) {
      this.selectedReferenceId = String(refId);
    }
  }

  openMemberModal(memberId: string): void {
    if (memberId) {
      this.selectedMemberId = memberId;
    }
  }

  closeAssistModal(): void {
    this.selectedReferenceId = null;
  }
}
